import "@hotwired/turbo-rails";
import "./jquery-import";
import "jquery-ui-dist/jquery-ui";

import "./shared/fontawesome-imports";
import "slick-carousel";

import "./shared/autocomplete";
import "./shared/confirm-overlay";
import "./workship/dropdown-hover";
import "./flash-message-close";
import "./header";
import "./frontpage/stageslider";
import "./frontpage/facts";
import "./frontpage/press";
import "./workship/upload-company-logo";
import "./workship/draganddrop";
import "./shared/smoothscroll";
import "./workship/checkbox-fix-for-errors";
import "./workship/form_validation";
import "./workship/add-dynamic-form-field";
import "./workship/qualified-profile-overlay-close";
import "./workship/open-close-jobs";
import "./product-page";
import "./workship/toggle-bnet-overlay";
import "./workship/toggle-industries-container";
import "./workship/jobs-search-filter";
import "./shared/ajax-updates";

require("trix");
require("@rails/actiontext");
